import LoginContent from "@containers/LoginContainer/LoginContent";
import React from "react";

function Login() {
  return <LoginContent />;
}

export default Login;
